import React, { useState } from "react";
import {
  Layout,
  Menu,
  Button,
  Drawer,
  Typography,
} from "antd";

import { Link } from "react-router-dom";

import AirplaneIcon from '../assets/images/airplane.png';
import CarIcon from '../assets/images/car.png';
import TourismIcon from '../assets/images/tourism.png';

import SawariLogo from '../assets/sawari-logo.png';
import CurrencySelector from "../context/CurrencySelector";
import { MenuOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;
function HeaderBar() {
    const [visible, setVisible] = useState(false);
    return (
        <Header>
            <Link to="/"><img src={SawariLogo} className="object-contain max-h-[90px] w-auto" style={{marginTop: '10px'}}/></Link>
            <div className="hidden md:flex justify-center header-col header-nav">
                <Menu mode="horizontal" defaultSelectedKeys={["1"]}>
                    <Menu.Item key="1">
                        <Link to="/airport-transfers">
                            <img src={AirplaneIcon} width={24} height={24} className="inline" />
                            <span style={{
                                color: 'black',
                                fontWeight: 'bold'
                            }}> Airport Transfers</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="2">
                        <Link to="/vehicle-rentals">
                            <img src={CarIcon} width={24} height={24} className="inline" />
                            <span style={{
                                color: 'black',
                                fontWeight: 'bold'
                            }}>Vehicle Rentals</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="3">
                        <Link to="/tourism-packages">
                            <img src={TourismIcon} width={24} height={24} className="inline" />
                            <span style={{
                                color: 'black',
                                fontWeight: 'bold'
                            }}> Tourism Packages</span>
                        </Link>
                    </Menu.Item>
                </Menu>
            </div>
            <div className="header-col header-btn hidden md:flex">
                <CurrencySelector />
            </div>
            <div 
            className="flex items-center justify-center p-2 ml-auto h-full cursor-pointer lg:hidden mt-1"
            onClick={() => setVisible(true)}
            >
            <svg
                width="32" 
                height="32" 
                viewBox="0 0 32 32" 
                fill="currentColor"
                className="text-black"
            >
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
            </svg>
            </div>

            {/* Mobile Drawer (Dropdown Menu) */}
            <Drawer
                title={<span className="text-lg font-semibold">Menu</span>}
                placement="right"
                onClose={() => setVisible(false)}
                open={visible}
                closeIcon={<span style={{ fontSize: "24px", cursor: "pointer" }}>✖</span>} // Unicode Close Icon
            >
                <Menu mode="vertical" className="border-none">
                <Menu.Item key="1">
                    <Link to="/airport-transfers">
                    <img src={AirplaneIcon} width={24} height={24} className="inline mr-2" />
                    Airport Transfers
                    </Link>
                </Menu.Item>
                <Menu.Item key="2">
                    <Link to="/vehicle-rentals">
                    <img src={CarIcon} width={24} height={24} className="inline mr-2" />
                    Vehicle Rentals
                    </Link>
                </Menu.Item>
                <Menu.Item key="3">
                    <Link to="/tourism-packages">
                    <img src={TourismIcon} width={24} height={24} className="inline mr-2" />
                    Tourism Packages
                    </Link>
                </Menu.Item>
                </Menu>
                <div className="mt-4">
                <CurrencySelector />
                </div>
            </Drawer>
        </Header>
    )
}

export default HeaderBar